import { useContext, useState } from 'react'
import {CustomerContext} from '../provider/_context'
import { useProductAction } from '../provider/_reducer'
import { sendRequestAuth } from '../../../api/api'
import config from '../../../config'
import { removeAcent } from 'common/fieldText/_functions'

export const useProductTab = (data) => {
  const { pageState, pageDispatch } = useContext(CustomerContext)
  const { productTab } = pageState.table
  const { detail } = pageState.table
  const { filter } = productTab

  const searchActiveValue = filter.search.activeValue
  const searchValue = filter.search.value

  const handleSearchChange = value => {
    pageDispatch({
      type: useProductAction.FILTER_SEARCH_UPDATE,
      payload: value,
    })
  }
// ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====
  // ===== ===== ===== ===== =====
  // CATEGORY FILTER
  // ===== ===== ===== ===== =====
  const categoryList = filter?.category?.list
  const categoryListOrigin = filter?.category?.listOrigin
  const categoryValue = filter?.category?.value
  const categoryActiveValue = filter?.category?.activeValue

  const handleCategoryChange = value => {
    pageDispatch({
      type: useProductAction.FILTER_CATEGORY_VALUE_UPDATE,
      payload: value
    })
  }

  const handleCategoryKeywordChange = data => {
    const formatDataValue = data?.value
      ? removeAcent(data?.value?.toLowerCase())
      : ''

    const categoryListData = categoryListOrigin.filter(item => {
      const formatNameItem = item?.title
        ? removeAcent(item?.title.toLowerCase())
        : ''
      if (formatNameItem.includes(formatDataValue?.trim())) return true
      return false
    })
    pageDispatch({
      type: useProductAction.FILTER_CATEGORY_LIST_UPDATE,
      payload: categoryListData
    })
  }
  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====


  const queries = {
    category_id: categoryValue?.id || '',
    product_name: searchValue || '',
    per_page: 999,
    start: (productTab?.table?.pagination?.active * productTab?.table?.pagination?.amount) || 0,
  }

  const applyOtherFilter = async () => {
    const qs = {
      ...queries,
      start: 0
    }
    let queryString = '?'
    let i = 0
    for (const [key, value] of Object.entries(qs)) {
      queryString += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }
    fetchQrbyProduct(queryString)
  }


  const handleAmountChange = async n => {
    const qs = { ...queries, per_page: n, start: 0 }
    let queryString = '?'
    let i = 0
    for (const [key, value] of Object.entries(qs)) {
      queryString += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }
    fetchQrbyProduct(queryString)

  }

  const handlePageChange = async page => {
    const amount = productTab?.table?.pagination?.amount || 999
    const qs = {
      ...queries,
      per_page: productTab?.table?.pagination?.amount,
      start: page * amount
    }
    let queryString = '?'
    let i = 0
    for (const [key, value] of Object.entries(qs)) {
      queryString += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }
    fetchQrbyProduct(queryString)
  }

  const fetchQrbyProduct = async (qs) => {
    pageDispatch({
      type: useProductAction.TABLE_LOADING_DISPLAY,
      payload: true
    })
    const response = await Promise.all([
      sendRequestAuth('get', `${config.API}/sale/customer/detail/${detail?.id}/purchased-products${qs}`)
    ])
    if (response[0]?.data?.success) {
      pageDispatch({
        type: useProductAction.TABLE_LOADING_DISPLAY,
        payload: false
      })
      const tearchers = response[0]?.data
      pageDispatch({
        type: useProductAction.TABLE_UPDATE_DISPLAY_LIST,
        payload: {
          list: tearchers?.data,
          listDefault: tearchers?.data,
          loading: false
        }
      })
      pageDispatch({
        type: useProductAction.TABLE_UPDATE_PAGINATION,
        payload: {
          active: Math.ceil(tearchers?.meta?.start / tearchers?.meta?.per_page),
          amount: tearchers?.meta?.per_page,
          total: Math.ceil(tearchers?.meta?.total / tearchers?.meta?.per_page),
          totalItems: tearchers?.meta?.total,
        }
      })

      pageDispatch({
        type: useProductAction.TABLE_SELECTED_LIST_UPDATE,
        payload: {selected: {list: []}},
      })
    }
  }
  return {
    table: productTab.table,
    queries,
    search: {
      value: searchValue,
      activeValue: searchActiveValue,
      onChange: handleSearchChange,
    },
    categoryFilter: {
      value: categoryValue,
      activeValue: categoryActiveValue,
      list: categoryList,
      onChange: handleCategoryChange,
      onKeywordChange: handleCategoryKeywordChange
    },
    pagination: {
      onAmountChange: handleAmountChange,
      onPageChange: handlePageChange,
    },

    methods: {
      applyOtherFilter,
    },
  }
}